<template>
  <panel no-button="true" :title="'Edit ' + item.name">
    <p v-if="errors.length">Please correct the following error(s):</p>
    <ul>
      <li v-for="error in errors" :key="error" style="color: red">
        {{ error }}
      </li>
    </ul>
    <form @submit.prevent="submit">
      <div class="form-group row m-b-15">
        <label class="col-form-label col-md-2">Name</label>
        <div class="col">
          <input type="text" class="form-control" v-model="item.name" />
        </div>
      </div>

      <b-button-group>
        <b-button variant="secondary" @click="cancel({ name: 'companies' })">
          Cancel
        </b-button>
        <b-button type="submit" class="submit btn-yellow"> Save </b-button>
        <b-button v-if="isSystemAdmin" variant="danger" v-b-modal.modalConfirm>
          Delete
        </b-button>
      </b-button-group>
    </form>

    <delete-modal v-if="item.id" :on-confirm="() => onDelete(item.id)">
      <template v-slot:content>
        <h5><i class="fa fa-info-circle"></i>Delete</h5>
        <p>Are you sure you want to delete {{ item.name }}?</p>
      </template>
    </delete-modal>
  </panel>
</template>

<script>
import FormMixin from '../../mixins/FormMixin'
import UserMixin from '../../mixins/UserMixin'
import DeleteModal from '../../components/shared/DeleteModal'
export default {
  components: {
    DeleteModal
  },
  mixins: [FormMixin, UserMixin],
  data: () => ({
    errors: []
  }),
  methods: {
    validate() {
      if (this.item.name) {
        return true
      }

      this.errors = []

      if (!this.item.name) {
        this.errors.push('Name required!')
      }
    }
  }
}
</script>
